import './stats-leaders/reducer/types';

/**
 * @typedef {object} StatsProState
 * @property {StatsLeadersState} statsLeaders
 */

/**
 * @typedef {'seasons'|'rounds'} StatsLeadersStatsType
 */